import React from 'react';
import CheckIcon from '../assets/CheckIcon.svg';
import ownershipImg from '../assets/OwnerShip.svg';
import './CanadianOwnershipSection.css';

const CanadianOwnershipSection = () => {
  const benefits = [
    'Keep transportation profits in Canadian communities',
    'Create jobs for Canadian workers',
    'Support Canadian technology innovation',
    'Build stronger local economies',
    "Invest in your neighbors' success"
  ];

  return (
    <section id="ownership" className="canadian-ownership-section">
      <div className="section-container">
        <div className="ownership-grid">
          <div className="ownership-content">
            <h2 className="section-title">Why Canadian Ownership Matters</h2>
            <p className="ownership-intro">When you choose KabX, you're choosing to:</p>
            <ul className="ownership-list">
              {benefits.map((benefit, index) => (
                <li key={index} className="ownership-item">
                  <img src={CheckIcon} alt="check" className="check-icon" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
            <div className="ownership-stat">
              <p className="stat-text">
                <strong>73% of Canadians</strong> prefer to support locally-owned businesses when quality and pricing are comparable. With KabX, you get <strong>superior service AND community impact</strong>.
              </p>
            </div>
          </div>
          <div className="ownership-visual">
            <img
              src={ownershipImg}
              alt="Why Choose KabX"
              className="why-choose-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CanadianOwnershipSection;